import { BaseContentService } from './base-content-service';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DashboardContent } from './def/dashboard-data';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';

@Injectable()
export class DashboardContentService extends BaseContentService<
  DashboardContent
> {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService
  ) {
    super(http, configService, DashboardContentService.staticDashboardData);
  }

  get data$(): Observable<DashboardContent> {
    if (!this.loaded) {
      return this.getDashboardBannerData();
    }

    return of(this.data);
  }

  getDashboardBannerData(): Observable<DashboardContent> {
    const url = `${this.serviceBaseUrl}dashboard`;
    return this.get<DashboardContent>(url).pipe(
      map(data => {
        this.data = this.dashboardDataMapper(data);
        this.loaded = true;
        return this.data;
      }),
      catchError(this.handleError)
    );
  }

  private dashboardDataMapper(data: DashboardContent): DashboardContent {
    if (!data) return;

    return data;
  }

  private static staticDashboardData: DashboardContent = {
    pageName: 'dashboard',
    grids: [
      {
        gridName: '',
        rowText: '',
        deleteRow: false,
        paging: true,
        pageLength: 10,
        searching: true,
        ordering: true,
        isCheckBoxRequired: false,
        responsive: true,
        isVisibility: true,
        isPersist: false,
        isRadioBoxRequired: false,
        allowExcelExport: true,
        allowPdfExport: true,
        addRowType: null,
        popDataConfig: null,
        columnDefinitions: [
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 1
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 2
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 3
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 4
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 5
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 6
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 7
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 8
          }
        ]
      },
      {
        gridName: '',
        rowText: '',
        deleteRow: false,
        paging: true,
        pageLength: 10,
        searching: true,
        ordering: true,
        isCheckBoxRequired: false,
        responsive: true,
        isVisibility: true,
        isPersist: false,
        isRadioBoxRequired: false,
        allowExcelExport: true,
        allowPdfExport: true,
        addRowType: null,
        popDataConfig: null,
        columnDefinitions: [
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 1
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 2
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 3
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 4
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 5
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 6
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 7
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 8
          }
        ]
      },
      {
        gridName: '',
        rowText: '',
        deleteRow: false,
        paging: true,
        pageLength: 10,
        searching: true,
        ordering: true,
        isCheckBoxRequired: false,
        responsive: true,
        isVisibility: true,
        isPersist: false,
        isRadioBoxRequired: false,
        allowExcelExport: true,
        allowPdfExport: true,
        addRowType: null,
        popDataConfig: null,
        columnDefinitions: [
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 1
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 2
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 3
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 4
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 5
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 6
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 7
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 8
          }
        ]
      },
      {
        gridName: '',
        rowText: '',
        deleteRow: false,
        paging: true,
        pageLength: 10,
        searching: true,
        ordering: true,
        isCheckBoxRequired: false,
        responsive: true,
        isVisibility: true,
        isPersist: false,
        isRadioBoxRequired: false,
        allowExcelExport: true,
        allowPdfExport: true,
        addRowType: null,
        popDataConfig: null,
        columnDefinitions: [
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 1
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 2
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 3
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 4
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 5
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 6
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 7
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 8
          }
        ]
      },
      {
        gridName: '',
        rowText: '',
        deleteRow: false,
        paging: true,
        pageLength: 10,
        searching: true,
        ordering: true,
        isCheckBoxRequired: false,
        responsive: true,
        isVisibility: true,
        isPersist: false,
        isRadioBoxRequired: false,
        allowExcelExport: true,
        allowPdfExport: true,
        addRowType: null,
        popDataConfig: null,
        columnDefinitions: [
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 1
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 2
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 3
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 4
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 5
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 6
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 7
          },
          {
            fieldName: '',
            label: '',
            isKeyColumn: false,
            isVisible: true,
            isSortable: true,
            alignment: '',
            columnType: '',
            orderId: 8
          }
        ]
      }
    ],
    accordians: [
      {
        heading: '',
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: null,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 1,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 2,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 3,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    data: [
      {
        heading: '',
        title: '',
        description: '',
        text: '',
        image: {
          Alt: '',
          Border: '',
          Class: '',
          Height: 95,
          HSpace: 0,
          Src: '',
          VSpace: 0,
          Width: 114,
          MediaId: '',
          Title: '',
          Language: {
            Name: 'en'
          }
        },
        displayItems: []
      }
    ],
    media: [
      {
        heading: '',
        description: '',
        navigation: null,
        image: {
          Alt: '',
          Border: '',
          Class: '',
          Height: 881,
          HSpace: 0,
          Src: '',
          VSpace: 0,
          Width: 2250,
          MediaId: '',
          Title: '',
          Language: {
            Name: 'en'
          }
        },
        displayItems: []
      },
      {
        heading: '',
        description: '',
        navigation: null,
        image: {
          Alt: '',
          Border: '',
          Class: '',
          Height: 1320,
          HSpace: 0,
          Src: '',
          VSpace: 0,
          Width: 2250,
          MediaId: '',
          Title: '',
          Language: {
            Name: 'en'
          }
        },
        displayItems: []
      }
    ],
    messages: [
      {
        heading: '',
        description: '',
        image: {
          Alt: '',
          Border: '',
          Class: '',
          Height: 614,
          HSpace: 0,
          Src: '',
          VSpace: 0,
          Width: 566,
          MediaId: '',
          Title: '',
          Language: {
            Name: 'en'
          }
        },
        displayItems: []
      }
    ]
  };
}
